import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {KeycloakWrapperService} from '../keycloak/keycloak-wrapper.service';

export const noAuthGuard: CanActivateFn = async () => {
  const _kcService: KeycloakWrapperService = inject(KeycloakWrapperService);
  const authenticated: boolean | undefined = _kcService.getKeycloakInstance().authenticated;
  if (authenticated) {
    await _kcService.logout().catch(e => console.error(e));
  }
  return true;
};

